import { render, staticRenderFns } from "./percentage.component.vue?vue&type=template&id=1745f988&scoped=true&"
import script from "./percentage.component.vue?vue&type=script&lang=js&"
export * from "./percentage.component.vue?vue&type=script&lang=js&"
import style0 from "./percentage.component.vue?vue&type=style&index=0&id=1745f988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745f988",
  null
  
)

export default component.exports